import {
  apiApiKeyIdentitiesPlugin,
  apiEntityIdentitiesPlugin,
} from "../plugins/apiIdentitiesPlugin";
import { profileMenuPlugin } from "../plugins/profileMenuPlugin";
import { segmentPlugin } from "../plugins/segmentPlugin";

const isProduction = process.env.ZUDOKU_PUBLIC_NODE_ENV === "production";

if (isProduction && !process.env.ZUDOKU_PUBLIC_SEGMENT_WRITE_KEY) {
  throw new Error("ZUDOKU_PUBLIC_SEGMENT_WRITE_KEY is required in production");
}

const plugins = [
  apiApiKeyIdentitiesPlugin,
  ...(!isProduction ? [apiEntityIdentitiesPlugin] : []),
  profileMenuPlugin,
  ...(segmentPlugin ? [segmentPlugin] : []),
];

export { plugins };
